import React from 'react'
import Navbar from '../components/Navbar'
import DownloadPage from '../components/DownloadPage'

function LDownloadPage() {
    return (
        <div>
            <Navbar />
            <DownloadPage />
        </div>
    )
}

export default LDownloadPage